import {
  DUPLICATE_USER_OR_EMAIL_MESSAGE,
  UPLOAD_SIZE_ERROR_MESSAGE,
  UPLOAD_CONNECTION_ERROR_MESSAGE,
} from "../config/constants";
import { normalizeText } from "./identity-utils";

export const wait = (delayMs) => new Promise((resolve) => setTimeout(resolve, delayMs));

export const isUploadNetworkError = (error = {}) => {
  const normalizedError = normalizeText(error?.message).toLowerCase();

  return (
    normalizedError.includes("failed to fetch") ||
    normalizedError.includes("network request failed") ||
    normalizedError.includes("load failed") ||
    normalizedError.includes("networkerror") ||
    normalizedError.includes("network changed")
  );
};

export const hasPreregistrationConflict = (data = {}) =>
  Boolean(data?.conflicts?.preregistrationPending);

export const getUploadErrorMessage = ({ response, data, error } = {}) => {
  if (data?.message) {
    return data.message;
  }

  if (response?.status === 413) {
    return UPLOAD_SIZE_ERROR_MESSAGE;
  }

  if (
    isUploadNetworkError(error)
  ) {
    return UPLOAD_CONNECTION_ERROR_MESSAGE;
  }

  return data?.message || "No fue posible enviar la solicitud.";
};

export const hasUserOrEmailConflict = (data = {}, fallbackMessage = "") => {
  const conflicts = data?.conflicts || {};
  const normalizedMessage = normalizeText(fallbackMessage);
  const mentionsUserOrEmail = /usuario|correo|email|auth0/i.test(normalizedMessage);
  const mentionsDuplicate = /existe|registrad|duplic|choca/i.test(normalizedMessage);

  return (
    Boolean(conflicts.medicalStaff) ||
    Boolean(conflicts.user) ||
    Boolean(conflicts.auth0Email) ||
    Boolean(conflicts.auth0Username) ||
    Boolean(conflicts.usernameInDatabase) ||
    (mentionsUserOrEmail && mentionsDuplicate)
  );
};

export const getDuplicateUserOrEmailMessage = (data = {}, fallbackMessage = "") =>
  hasUserOrEmailConflict(data, fallbackMessage)
    ? DUPLICATE_USER_OR_EMAIL_MESSAGE
    : fallbackMessage;
